import { format, parseISO } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';

export const displaySnapshotTime = (isoTimestamp, locale) => {
  const date = parseISO(isoTimestamp);
  const dateFormat = 'MMMM d, yyyy'; // Format: "July 2, 2024"
  const selectedLocale = locale === 'fr' ? fr : enUS;

  return format(date, dateFormat, { locale: selectedLocale });
};

export const getUUIDFromURL = () => {
  // Get the pathname from the current URL
  const pathname = window.location.pathname;

  // Define a regex pattern to match any characters after /c/ and before an optional trailing slash
  const uuidPattern = /^\/c\/([^/]+)\/?$/;

  // Use the pattern to extract the UUID
  const match = pathname.match(uuidPattern);

  // Return the UUID if matched, otherwise return null
  return match ? match[1] : null;
}